import React, { useState } from 'react';
import { Chart,registerables } from 'chart.js'
import {Pie} from "react-chartjs-2"

Chart.register(...registerables);

function InstructorChart({courses}) {

    const [currentChart,setCurrentChart] = useState("students");

    // function to generate random colors
    function getRandomColors(numColors)
    {
        const colors = [];
        for(let i = 0;i<numColors;i++)
        {
            const color = `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)},
                ${Math.floor(Math.random() * 256)})`;
                colors.push(color);
        }
        return colors;
    }

    // create data for chart student info
    const chartDataForStudents = {
        labels: courses.map((course)=> course.courseName),
        datasets: [
            {
                data: courses.map((course)=> course.totalStudentsEnrolled),
                backgroundColor: getRandomColors(courses.length),
            }
        ]
    }

    // create data for chart income info
    const chartDataForIncome = {
        labels: courses.map((course)=> course.courseName),
        datasets: [
            {
                data: courses.map((course)=> course.totalAmountGenerated),
                backgroundColor: getRandomColors(courses.length),
            }
        ]
    }

    // options
    const options = {

    };

    return (
        <div className='bg-richblack-800  rounded-md p-4'>
            <p className='text-xl font-semibold'>Visualise</p>
            <div className='flex gap-x-5 mt-5 mb-5'>
                <button className={`${currentChart === "students" ? ("text-yellow-25 bg-richblack-600 px-2 py-1 rounded-md") : ("opacity-60 text-yellow-25")}`} onClick={()=>setCurrentChart("students")}>Students</button>
                <button className={`${currentChart === "income" ? ("text-yellow-25 bg-richblack-600 px-2 py-1 rounded-md") : ("opacity-60 text-yellow-25")}`} onClick={()=>setCurrentChart("income")}>Income</button>
            </div>
            {/* <div className='flex justify-center items-center'> */}
                {/* <div className='w-[28rem]'> */}
                <div className="relative flex justify-center mx-auto aspect-square h-[29rem] max-[450px]:h-full w-full">
                    <Pie radius={20} data={currentChart === "students" ? chartDataForStudents : chartDataForIncome}
                    options={options}/>
                </div>
            {/* </div> */}
        </div>
    );
}

export default InstructorChart;